// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__rCPWr","clinicsSelect":"styles_clinicsSelect__1n2UR"};